export default {
  install(Vue) {
    // Integer (có thể âm hoặc dương)
    Vue.directive('only-number-int', {
      bind(el) {
        el.addEventListener('keypress', e => {
          const char = e.charCode
          const value = el.value
          if (char >= 48 && char <= 57) return
          if (char === 45 && !value.includes('-') && el.selectionStart === 0) return

          e.preventDefault()
        })
      },
    })

    // Integer dương (chỉ số 0-9)
    Vue.directive('only-number-int-unsigned', {
      bind(el) {
        el.addEventListener('keypress', e => {
          const char = e.charCode
          if (char < 48 || char > 57) {
            e.preventDefault()
          }
        })
      },
    })

    // Số thực dương (1 dấu chấm)
    Vue.directive('only-number-unsigned', {
      bind(el) {
        el.addEventListener('keypress', e => {
          const charCode = e.charCode
          const value = el.value
          if (charCode >= 48 && charCode <= 57) return
          if (charCode === 46 && !value.includes('.')) return
          e.preventDefault()
        })
      },
    })

    // Số thực có thể âm (cho phép 0-9, '-', '.')
    Vue.directive('only-number', {
      bind(el) {
        el.addEventListener('keypress', e => {
          const charCode = e.charCode
          const value = el.value
          if (charCode >= 48 && charCode <= 57) return
          if (charCode === 45 && !value.includes('-') && el.selectionStart === 0) return
          if (charCode === 46 && !value.includes('.')) return

          e.preventDefault()
        })
      },
    })
  },
}
